const dev = {
	API_URL: process.env.REACT_APP_BASE_URL_DEV
};

const staging = {
	API_URL: process.env.REACT_APP_BASE_URL_STAGING
};

//For live server
const production = {
	API_URL: process.env.REACT_APP_BASE_URL_PRODUCTION
};

if (process.env.REACT_APP_ENV === "dev") module.exports = dev;
else if (process.env.REACT_APP_ENV === "staging") module.exports = staging;
else if (process.env.REACT_APP_ENV === "production") module.exports = production;
else module.exports = staging;
